<script>
    import FooterSection from "./FooterSection.svelte";
    import OpeningHours from "../opening-hours/OpeningHours.svelte";
    import Spacer from "../Spacer.svelte";
    import { CONTACT_EMAIL_ADDRESS, CONTACT_PHONE_NUMBER, SHIPPINGS } from "../../constants";
</script>

<footer class="sm:mt-28">
    <div class="mt-16 px-4 mx-auto max-w-xl md:max-w-3xl lg:max-w-6xl">
        <div class="flex flex-wrap">
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <FooterSection>
                    <svelte:fragment slot="title">Trygg E-handel</svelte:fragment>
                    <svelte:fragment slot="body">
                        <ul>
                            <li>30 dagars öppet köp</li>
                            <li>Frakt fr. {SHIPPINGS.regular.price} kr</li>
                            <li>Gratis returfrakt</li>
                            <li>Faktura, handla först betala sen</li>
                            <li>Fysisk butik</li>
                            <li>Över 60 000 nöjda kunder</li>
                        </ul>
                    </svelte:fragment>
                </FooterSection>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <FooterSection>
                    <svelte:fragment slot="title">Kundtjänst</svelte:fragment>
                    <svelte:fragment slot="body">
                        <div>
                            Har du svårt att hitta rätt matta?
                            <br />
                            Ring eller maila till oss!
                        </div>
                        <div>
                            Telefon:
                            <a href="callto:+46{CONTACT_PHONE_NUMBER.substring(1).replace(/\s+|-/g, '')}"
                                >{CONTACT_PHONE_NUMBER}</a
                            >
                        </div>
                        <div class="overflow-x-hidden">
                            Email:
                            <a href={`mailto:${CONTACT_EMAIL_ADDRESS}`}>
                                {CONTACT_EMAIL_ADDRESS}
                            </a>
                        </div>
                        <div>
                            Facebook:
                            <a href="https://facebook.com/NylandersMattorAB" target="_blank" rel="external noreferrer"
                                >NylandersMattorAB</a
                            >
                        </div>
                    </svelte:fragment>
                </FooterSection>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <FooterSection>
                    <svelte:fragment slot="title">Öppettider butik</svelte:fragment>
                    <OpeningHours slot="body" />
                </FooterSection>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <FooterSection>
                    <svelte:fragment slot="title">Nyttiga länkar</svelte:fragment>
                    <svelte:fragment slot="body">
                        <div class="flex flex-row">
                            <ul class="w-1/2">
                                <li>
                                    <a href="/villkor" aria-label="Gå till köpvillkor">Köpvillkor</a>
                                </li>
                                <li>
                                    <a href="/cookie-policy" aria-label="Gå till cookies">Cookies</a>
                                </li>
                                <li>
                                    <a href="/integritetspolicy" aria-label="Gå till integritetspolicy"
                                        >Integritetspolicy</a
                                    >
                                </li>
                                <li>
                                    <a href="/om-nylanders-mattor" aria-label="Läs om oss">Om oss</a>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <a href="/kontakta-oss-i-boras" aria-label="Gå till kontakta oss sidan"
                                        >Kontakta oss</a
                                    >
                                </li>
                                <li>
                                    <a href="/mattbloggen" aria-label="Gå till vår blogg">Blogg</a>
                                </li>
                                <li>
                                    <a href="/kopa-matta-online" aria-label="Gå till tips &amp; råd">Tips &amp; råd</a>
                                </li>
                            </ul>
                        </div>
                    </svelte:fragment>
                </FooterSection>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <FooterSection>
                    <svelte:fragment slot="title">Hitta oss på internet</svelte:fragment>
                    <svelte:fragment slot="body">
                        <ul class="overflow-x-hidden">
                            <li>
                                Instagram:
                                <a
                                    href="https://www.instagram.com/nylandersmattor/"
                                    rel="external noreferrer"
                                    target="_blank">instagram.com/nylandersmattor</a
                                >
                            </li>
                            <li>
                                Facebook:
                                <a
                                    href="https://facebook.com/NylandersMattorAB"
                                    rel="external noreferrer"
                                    target="_blank">facebook.com/NylandersMattorAB</a
                                >
                            </li>
                            <li>
                                Youtube:
                                <a
                                    href="https://www.youtube.com/c/NylandersMattorOnline"
                                    rel="external noreferrer"
                                    target="_blank">youtube.com/NylandersMattorOnline</a
                                >
                            </li>
                        </ul>
                    </svelte:fragment>
                </FooterSection>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <FooterSection>
                    <svelte:fragment slot="title">Företagsinfo</svelte:fragment>
                    <svelte:fragment slot="body">
                        Nylanders Mattor AB<br />
                        Orgnr:556741-8511<br />
                        Boråsvägen 66<br />
                        516 34 Dalsjöfors
                    </svelte:fragment>
                </FooterSection>
            </div>
        </div>
    </div>
    <Spacer />
    <div class="copyright">
        <div>&copy; Copyright Nylanders Mattor AB {new Date().getFullYear()}</div>
    </div>
</footer>

<style>
    a {
        color: rgba(0, 0, 0, 0.6);
    }
    footer {
        background: #edeff1;
        padding-bottom: 0;
        padding-top: 10px;
        width: 100%;
        border-top: 1px solid #ddd;
        color: rgba(0, 0, 0, 0.6);
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .copyright {
        background-color: rgba(42, 42, 42, 1);
        height: 2rem;
        width: 100%;
        color: rgba(255, 255, 255, 0.8);
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .copyright > div {
        font-size: 0.8rem;
        font-weight: 200;
        margin: 0;
        padding: 0;
    }
</style>
